import { COMMAND_CENTER_ROOT } from './commandCenterRoutes'
import { Navigate, useNavigate, useParams } from 'react-router-dom'
import { GovernanceProvider, GovRecordWorkspace, govRecordPath, GOV_MODULES, OLV_SUITE_ROOT, type GovModule } from './olivium/governance'

/**
 * V2 Olivium governance record — Universal Record Workspace route wrapper.
 *
 * Registered + auth-gated (see router.tsx):
 *   /square/command-center/olivium/:module/:recordId
 *
 * Static olivium child routes (secure-access, portal-factory, portals) rank
 * above this dynamic pair in React Router v6, so this only ever resolves the
 * seven governance modules. An unknown module falls back honestly to the suite
 * home rather than rendering an empty page.
 */
export default function SquareCodeOliviumRecordRoute() {
  const navigate = useNavigate()
  const { module, recordId } = useParams<{ module: string; recordId: string }>()

  if (!module || !recordId || !GOV_MODULES.includes(module as GovModule)) {
    return <Navigate to={OLV_SUITE_ROOT} replace />
  }

  return (
    <GovernanceProvider>
      <GovRecordWorkspace
        module={module as GovModule}
        recordId={recordId}
        onOpenRecord={(m, id) => navigate(govRecordPath(m, id))}
        onOpenPath={(to) => navigate(to)}
        onHome={() => navigate(COMMAND_CENTER_ROOT)}
      />
    </GovernanceProvider>
  )
}
